import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DurationPicker from 'components/durationPicker/duration-picker';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { Checkbox, Form, Input } from 'antd';
import _ from 'lodash';
import settings from 'settings';
import {
  convertToSelect, durationValidator, getKey, getLabel
} from 'library/helpers';
import REDUCER_KEY from 'reducers/reducer.keys';
import { list } from 'actions';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  legTypes: state.api.availabilityLegTypes.data.results,
  inFlight: state.api.availabilityLegTypes.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadLegTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(REDUCER_KEY.availabilityLegTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name, type, duration, active
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    type: Form.createFormField({ value: convertToSelect(type) }),
    duration: Form.createFormField({ value: duration }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form, loadLegTypes, legTypes
}) => {
  const { getFieldDecorator } = form;
  const {
    active, duration, name, type
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Leg name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Leg Type">
        {
          getFieldDecorator('type', {
            initialValue: type,
            rules: [
              {
                required: true,
                message: 'Please enter the Leg Type.'
              }
            ]
          })(
            <ExtendedSelect
              placeholder="Select Leg Type"
              dataSource={legTypes}
              optionKey={getKey}
              optionLabel={getLabel}
              disabled={readonly}
              onSearch={loadLegTypes}
              onFocus={loadLegTypes}
            />
          )
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Duration">
        {
          getFieldDecorator('duration', {
            initialValue: duration,
            rules: [
              {
                required: true,
                message: 'Please enter the Duration.'
              },
              {
                message: 'Duration must not be less than 15 minutes',
                validator: durationValidator
              }
            ]
          })(
            <DurationPicker disabled={readonly} />
          )
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  legTypes: PropTypes.array,
  loadLegTypes: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  legTypes: [],
  loadLegTypes() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedLegFormInput = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(FormInput);

const LegFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedLegFormInput));

export default LegFormInput;
